export default "/_next/static/images/313f49d1601992ef4581a69a2b17bb9a.png";